export interface IProductionDefaultsResponse {  
  dateFrom: Date;
  dateTo: Date;  
}

export class ProductionDefaultsResponse implements IProductionDefaultsResponse {  
  dateFrom: Date;
  dateTo: Date;
}